const p = {
  biggie: "48px",
  large: "48px",
  medium: "40px",
  small: "32px",
  teenie: "32px"
}, s = {
  1: "48px",
  2: "64px",
  3: "96px",
  4: "128px",
  5: "160px",
  6: "192px",
  7: "224px",
  8: "288px",
  9: "352px",
  10: "448px",
  100: "100%"
}, x = {
  root: 8
}, i = {
  heights: p,
  widths: s,
  spacing: x
};
export {
  x as a,
  p as h,
  i as s,
  s as w
};
//# sourceMappingURL=sizes-DktS74Qp.mjs.map
